import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container blog-content" }
const _hoisted_2 = { class: "blog-posts" }
const _hoisted_3 = { class: "blog-categories" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Categories", -1)
const _hoisted_5 = { class: "tags" }
const _hoisted_6 = {
  key: 0,
  class: "container blog-content"
}
const _hoisted_7 = { class: "blog-pagination" }
const _hoisted_8 = { class: "blog-pagination__page" }

import { computed, onMounted, ref } from 'vue'
import { onBeforeRouteLeave } from 'vue-router'
import { blogData, BlogPost } from '@/assets/data/blog'
import { delay } from '@/utils/async'
import { urlFriendlyTitle } from '@/utils/text'
import { now } from '@/utils/time'
import { useMeta } from 'vue-meta'

import Hero from '@/components/Hero.vue'
import MediaLinkPreview from '@/components/MediaLinkPreview.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BlogView',
  setup(__props) {

const isShowing = ref<boolean>(false)
const page = ref<number>(1)
const postsPerPage: number = 10

const blogPosts = computed<BlogPost[]>(() => {
  const start = postsPerPage * (page.value - 1)
  const end = postsPerPage * page.value
  return blogData
    .filter(bd => new Date(bd.date).getTime() < now.getTime())
    .slice(start, end)
})

const isLastPage = computed<boolean>(() => {
  const totalPages = blogData.filter(bd => new Date(bd.date).getTime() < now.getTime()).length / postsPerPage
  return page.value >= totalPages
})

const tags = computed<string[]>(() => {
  let tags = blogData.filter(bd => new Date(bd.date).getTime() < now.getTime()).flatMap(x => x.tags)
  let uniqueTags: string[] = []
  tags.forEach(t => {
    if(uniqueTags.indexOf(t) < 0) uniqueTags.push(t)
  })
  return uniqueTags.sort()
})

function handleClickNextPage() {
  page.value++
}

function handleClickPreviousPage() {
  page.value--
}

onBeforeRouteLeave(async () => {
  isShowing.value = false
  await delay(800)
})

onMounted(async () => {
  useMeta({ title: 'Blog' })
  await delay(200)
  isShowing.value = true
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["blog page-container transition__page", { 'isShowing': isShowing.value }])
  }, [
    _createVNode(Hero, {
      headline: "ForeChamp Blog",
      imageSrc: "blog-hero.jpg",
      imageAlt: "Blog hero image"
    }),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(blogPosts), (bp, bpIndex) => {
          return (_openBlock(), _createBlock(MediaLinkPreview, {
            key: bpIndex,
            cta: "Click To Read",
            id: bp.date,
            image: bp.image,
            media: "blog",
            size: "short",
            title: bp.title
          }, null, 8, ["id", "image", "title"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tags), (t) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              class: "tag transition",
              key: t,
              to: { name: 'BlogCategory', params: { tag: _unref(urlFriendlyTitle)(t) } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(t), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ])
      ])
    ]),
    (_unref(blogData).length > postsPerPage)
      ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (!_unref(isLastPage))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "blog-pagination__button transition",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClickNextPage()))
                }, "< Older Posts"))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, "Page " + _toDisplayString(page.value), 1),
            (page.value > 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "blog-pagination__button transition",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handleClickPreviousPage()))
                }, "Newer Posts >"))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})